<div
  appAddClassModifier
  class="nav-group"
  [class]="{
    'nav-group_is-children-hidden': !showChildren(),
    'nav-group_is-collapsed': isSideBarCollapsed(),
  }"
>
  <div class="nav-group__container">
    <div
      data-auto-id="toggleChildren"
      class="nav-group__title"
      (click)="toggleChildren()"
    >
      {{ group() }}
    </div>
    <div class="nav-group__item-container">
      @for (item of items(); track item) {
        <div class="nav-group__item">
          <app-nav-item [navItem]="item.options" />
        </div>
      }
    </div>
  </div>
</div>
